export default __webpack_public_path__ + "static/logo-105345cf45f736976e31285198774ed3.png";